import Constants from '@/Constants';
import { RequestAsyncReportData } from '@/models/RequestAsyncReportData';
import http from '@/services/HttpService';
import { getHost } from '@/services/UtilService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import {
    downloadLastReportFailure,
    downloadLastReportSuccess,
    generateAsyncReportFailure,
    generateAsyncReportSuccess,
    listReportProcessesFailure,
    listReportProcessesRequest as listReportProcessesRequestAction,
    listReportProcessesSuccess,
} from './action';
import { ReportTypes } from './types';

export function* generateAsyncReportRequest(action: PayloadAction<ReportTypes.GENERATE_ASYNC_REPORT_REQUEST, RequestAsyncReportData>) {
    const { reportId } = action.payload;
    try {
        yield call(http.post, `${Constants.TRACKING_REPORTS}/${reportId}/generate-async`, action.payload);

        yield put(generateAsyncReportSuccess(reportId));

        yield put(listReportProcessesRequestAction(reportId));
    } catch (error) {
        yield put(generateAsyncReportFailure(error, reportId));
    }
}

export function* listReportProcessesRequest(action: PayloadAction<ReportTypes.LIST_REPORT_PROCESSES_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, `${Constants.TRACKING_REPORTS}/${action.payload}/processes?offset=0&limit=5`);

        yield put(listReportProcessesSuccess(action.payload, data));
    } catch (error) {
        yield put(listReportProcessesFailure(error));
    }
}

export function* downloadLastReport(action: PayloadAction<ReportTypes.DOWNLOAD_LAST_REPORT_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, `${Constants.TRACKING_REPORTS}/${action.payload}/processes?offset=0&limit=5`);

        if (data) {
            const lastProcessCompleted = data
                .filter((it: { status: string }) => it.status === 'COMPLETED')
                .sort((a: { finishDate: any }, b: { finishDate: any }) => Number(b.finishDate) - Number(a.finishDate))[0];

            const reportUri = `${getHost()}${Constants.API_PATH}${Constants.TRACKING_REPORTS}/${action.payload}/download-async?token=${
                lastProcessCompleted.reportToken
            }`;
            window.open(reportUri, '_blank');
        }
        yield put(downloadLastReportSuccess());
    } catch (error) {
        yield put(downloadLastReportFailure(error));
    }
}
